<template>
  <div class="job-details">
    <div class="breadcrumb">
      <a-breadcrumb>
        <a-breadcrumb-item>
          <router-link to="/home">首页</router-link>
        </a-breadcrumb-item>
        <a-breadcrumb-item>
          <router-link to="/job">作业管理</router-link>
        </a-breadcrumb-item>
        <a-breadcrumb-item>作业详情</a-breadcrumb-item>
      </a-breadcrumb>
    </div>
    <div class="job-details-content">
      <div class="job-details-top">
        <a-row>
          <a-col :span="18" class="job-details-t-left">
            <div>协作组条码：{{ detail.hosBarCode }}</div>
            <div>
              <i class="iconfont icon-zuoyezhongxin"></i>
              <span>{{ detail.jobsName }}</span>
            </div>
          </a-col>
          <a-col :span="6" class="job-details-t-right">
            <a-button type="primary" v-auth="'105020'" @click="appoint()"
              >指派给</a-button
            >
          </a-col>
        </a-row>
      </div>
      <div class="job-details-center">
        <a-row>
          <a-col :span="16">
            <div class="job-details-c-t clearfix">
              <div class="content-container-left">
                <a-row>
                  <a-col :span="8">
                    <div class="job-status">
                      <div class="container">
                        <div
                          v-if="
                            detail.jobsStatus == 'failed' ||
                            detail.jobsStatus == 'psudone' ||
                            detail.jobsStatus == 'cancel' ||
                            detail.jobsStatus == 'done'
                          "
                        >
                          <div
                            class="circle circle-green"
                            v-if="detail.jobsStatus == 'done'"
                          >
                            <span
                              class="circle-node-name"
                              :title="
                                editData[0].nodeName ? editData[0].nodeName : ''
                              "
                              v-if="editData.length > 0"
                              >{{
                                editData[0].nodeName
                                  ? editData[0].nodeName
                                  : "- -"
                              }}<br /><span>{{
                                editData[0].status || "- -"
                              }}</span></span
                            >
                          </div>
                          <div>
                            <div
                              class="circle circle-hui"
                              v-if="detail.jobsStatus == 'cancel'"
                            >
                              <span
                                class="circle-node-name"
                                :title="
                                  editData[0].nodeName
                                    ? editData[0].nodeName
                                    : ''
                                "
                                v-if="editData.length > 0"
                                >{{
                                  editData[0].nodeName
                                    ? editData[0].nodeName
                                    : "- -"
                                }}<br /><span>{{
                                  editData[0].status || "- -"
                                }}</span></span
                              >
                            </div>
                            <div
                              class="circle circle-red"
                              v-if="
                                detail.jobsStatus == 'failed' ||
                                detail.jobsStatus == 'psudone'
                              "
                            >
                              <span
                                class="circle-node-name"
                                :title="
                                  editData[0].nodeName
                                    ? editData[0].nodeName
                                    : ''
                                "
                                v-if="editData.length > 0"
                                >{{
                                  editData[0].nodeName
                                    ? editData[0].nodeName
                                    : "- -"
                                }}<br /><span>{{
                                  editData[0].status || "- -"
                                }}</span></span
                              >
                            </div>
                          </div>
                        </div>
                        <div v-else>
                          <div v-if="editData.length > 0">
                            <div
                              class="circle circle-green"
                              v-if="
                                editData.length > 0 &&
                                editData[0].status == 'STAGE_DONE'
                              "
                            >
                              <span
                                class="circle-node-name"
                                :title="
                                  editData[0].nodeName
                                    ? editData[0].nodeName
                                    : ''
                                "
                                v-if="editData.length > 0"
                                >{{
                                  editData[0].nodeName
                                    ? editData[0].nodeName
                                    : "- -"
                                }}<br /><span>{{
                                  editData[0].status || "- -"
                                }}</span></span
                              >
                            </div>
                            <div>
                              <div
                                class="circle circle-hui"
                                v-if="
                                  editData.length > 0 &&
                                  editData[0].status == 'STAGE_PAUSE'
                                "
                              >
                                <span
                                  class="circle-node-name"
                                  :title="
                                    editData[0].nodeName
                                      ? editData[0].nodeName
                                      : ''
                                  "
                                  v-if="editData.length > 0"
                                  >{{
                                    editData[0].nodeName
                                      ? editData[0].nodeName
                                      : "- -"
                                  }}<br /><span>{{
                                    editData[0].status || "- -"
                                  }}</span></span
                                >
                              </div>
                              <div
                                class="circle circle-red"
                                v-if="
                                  (editData.length > 0 &&
                                    editData[0].status == 'STAGE_FAIL') ||
                                  editData[0].status == 'STAGE_LOST' ||
                                  editData[0].status == 'STAGE_INVALID_STATE'
                                "
                              >
                                <span
                                  class="circle-node-name"
                                  :title="
                                    editData[0].nodeName
                                      ? editData[0].nodeName
                                      : ''
                                  "
                                  v-if="editData.length > 0"
                                  >{{
                                    editData[0].nodeName
                                      ? editData[0].nodeName
                                      : "- -"
                                  }}<br /><span>{{
                                    editData[0].status || "- -"
                                  }}</span></span
                                >
                              </div>
                              <div
                                class="circle circle-img"
                                v-if="
                                  (editData.length > 0 &&
                                    editData[0].status == 'STAGE_RUNNING') ||
                                  editData[0].status == 'STAGE_QUEUED' ||
                                  editData[0].status == 'STAGE_INITIAL' ||
                                  editData[0].status == 'STAGE_SUBMITTED'
                                "
                              >
                                <span
                                  class="circle-node-name"
                                  :title="
                                    editData[0].nodeName
                                      ? editData[0].nodeName
                                      : ''
                                  "
                                  v-if="editData.length > 0"
                                  >{{
                                    editData[0].nodeName
                                      ? editData[0].nodeName
                                      : "- -"
                                  }}<br /><span>{{
                                    editData[0].status || "- -"
                                  }}</span></span
                                >
                              </div>
                            </div>
                          </div>
                          <div v-if="editData == null || editData.length <= 0">
                            <div class="circle circle-green">
                              <span>-<br /><span>-</span></span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </a-col>
                  <a-col :span="8" class="job-details-right-content">
                    <div class="group-content">
                      <div class="title">当前状态：</div>
                      <div class="value">{{ detail.jobsStatusName }}</div>
                    </div>
                  </a-col>
                  <a-col :span="8" class="job-details-right-content">
                    <div class="group-content">
                      <div class="title">操作：</div>
                      <div class="value">
                        <a-button
                          type="primary"
                          v-auth="'10506'"
                          @click="seeWorkProcess"
                          >查看作业进度
                        </a-button>
                        <a-drawer
                          title="作业进度"
                          :width="600"
                          @close="onClose"
                          :visible="visible"
                          :wrapStyle="{
                            height: '100%',
                            overflow: 'auto',
                            paddingBottom: '108px',
                          }"
                        >
                          <a-table
                            class="hospital-table"
                            size="middle"
                            :pagination="false"
                            :locale="{ emptyText: '暂无数据' }"
                            :rowKey="(record) => record.nodeName"
                            :dataSource="editData"
                          >
                            <a-table-column
                              data-index="nodeName"
                              key="nodeName"
                            >
                              <span class="table-th" slot="title"
                                >节点名称</span
                              >
                              <template slot-scope="text, record">
                                <span>{{ record.nodeName }}</span>
                              </template>
                            </a-table-column>
                            <a-table-column data-index="status" key="status">
                              <span class="table-th" slot="title">状态</span>
                              <template slot-scope="text, record">
                                <span>{{ record.status }}</span>
                              </template>
                            </a-table-column>
                            <a-table-column data-index="op" key="op">
                              <span class="table-th" slot="title">操作</span>
                              <template slot-scope="text, record, index">
                                <span
                                  style="color: blue; cursor: pointer"
                                  @click="downLoad()"
                                  v-if="index == 0"
                                  >日志下载</span
                                >
                              </template>
                            </a-table-column>
                          </a-table>
                        </a-drawer>
                        <!--<a-tooltip style="margin-left:10px;" placement="topLeft">-->
                        <!--<template slot="title" style="background:#ddd!important">-->
                        <!--<span>开发小哥哥正在快马加鞭赶工，敬请期待</span>-->
                        <!--</template>-->
                        <!--<a-button>高级操作</a-button>-->
                        <!--</a-tooltip>-->
                        <a-dropdown style="margin-left: 10px">
                          <a-button>高级操作</a-button>
                          <a-menu slot="overlay">
                            <!--<a-menu-item v-auth="'10507'">-->
                            <!--<a-icon type="pause-circle"/>-->
                            <!--<span @click="operateJob(3)">暂停作业</span>-->
                            <!--</a-menu-item>-->
                            <a-menu-item
                              v-auth="'105022'"
                              :class="
                                detail.jobsStatus == 'failed' ||
                                detail.jobsStatus == 'psudone' ||
                                detail.jobsStatus == 'cancel'
                                  ? ''
                                  : 'c-not-allowed'
                              "
                            >
                              <a-icon type="right-circle" />
                              <span @click="operateJob(1)">提交作业</span>
                            </a-menu-item>
                            <a-menu-item
                              v-auth="'10508'"
                              :class="
                                detail.jobsStatus == 'failed' ||
                                detail.jobsStatus == 'psudone'
                                  ? ''
                                  : 'c-not-allowed'
                              "
                            >
                              <a-icon type="sync" />
                              <span @click="operateJob(2)">重启作业</span>
                            </a-menu-item>
                            <a-menu-item
                              v-auth="'105021'"
                              :class="
                                detail.jobsStatus == 'running'
                                  ? ''
                                  : 'c-not-allowed'
                              "
                            >
                              <a-icon type="minus-circle" />
                              <span @click="operateJob(4)">取消作业</span>
                            </a-menu-item>
                          </a-menu>
                        </a-dropdown>
                      </div>
                    </div>
                  </a-col>
                </a-row>
                <a-row>
                  <a-col :span="8">
                    <div class="job-status-title">
                      <div class="right-group">
                        <div class="right-group-title">当前节点名称:</div>
                        <div
                          class="right-group-value"
                          v-if="editData.length > 0"
                        >
                          <span v-if="editData[0].nodeName">{{
                            editData[0].nodeName
                          }}</span>
                          <span v-else style="margin-left: 30px">--</span>
                        </div>
                        <div
                          v-if="editData == null || editData.length <= 0"
                          class="right-group-value"
                        >
                          -
                        </div>
                      </div>
                    </div>
                  </a-col>
                  <a-col :span="16"></a-col>
                </a-row>
                <a-row class="job-details-info-b">
                  <a-col :span="8">
                    <ul class="job-form-item">
                      <li class="job-form-item-label">开始时间:</li>
                      <li class="job-form-item-val">{{ detail.startTime }}</li>
                    </ul>
                  </a-col>
                  <a-col :span="8">
                    <ul class="job-form-item">
                      <li class="job-form-item-label">结束时间:</li>
                      <li class="job-form-item-val">{{ detail.endTime }}</li>
                    </ul>
                  </a-col>
                  <a-col :span="8">
                    <ul class="job-form-item">
                      <li class="job-form-item-label">耗时:</li>
                      <li class="job-form-item-val">
                        <a-tooltip placement="topLeft">
                          <template slot="title">
                            <span>{{ finishTime }}</span>
                          </template>
                          <span>{{ finishTime }}</span>
                        </a-tooltip>
                      </li>
                    </ul>
                  </a-col>
                </a-row>
              </div>
            </div>
            <div class="job-details-c-b">
              <div class="content-container-right">
                <div class="title">FQ文件</div>
                <div class="fq-container" v-if="fqList[0]">
                  <div class="fq-file">
                    <span>Sample：</span>
                    {{ fqList[0].sampleName }}
                  </div>
                  <div class="fq-file">
                    <span>read1：</span>
                    {{ fqList[0].read1 }}
                  </div>
                  <div class="fq-file">
                    <span>read2：</span>
                    {{ fqList[0].read2 }}
                  </div>
                </div>
              </div>
            </div>
          </a-col>
          <a-col :span="8" class="job-details-c-r">
            <ul class="job-form-item">
              <li class="job-form-item-label">流程名称:</li>
              <li class="job-form-item-val">{{ detail.flowName }}</li>
            </ul>
            <ul class="job-form-item">
              <li class="job-form-item-label">流程ID:</li>
              <li class="job-form-item-val">{{ detail.flowId }}</li>
            </ul>
            <ul class="job-form-item">
              <li class="job-form-item-label">作业ID:</li>
              <li class="job-form-item-val">{{ detail.jobsId }}</li>
            </ul>
            <ul class="job-form-item">
              <li class="job-form-item-label">分析人员:</li>
              <li class="job-form-item-val">
                {{ detail.analyzeName ? detail.analyzeName : "&nbsp;" }}
              </li>
            </ul>
            <ul class="job-form-item">
              <li class="job-form-item-label">BioflowID:</li>
              <li class="job-form-item-val">{{ detail.bioflowId || "-" }}</li>
            </ul>
            <ul class="job-form-item">
              <li class="job-form-item-label">系统创建时间:</li>
              <li class="job-form-item-val">{{ detail.createTime }}</li>
            </ul>
            <ul class="job-form-item">
              <li class="job-form-item-label">云平台创建时间:</li>
              <li class="job-form-item-val">{{ detail.cloudCreateTime }}</li>
            </ul>
            <ul class="job-form-item">
              <li class="job-form-item-label">作业目录:</li>
              <li class="job-form-item-val">{{ path || "-" }}</li>
            </ul>
          </a-col>
        </a-row>
      </div>
    </div>
    <page-model @close="closeModel" :visible="pvisible">
      <appoint
        v-if="pvisible && isAppoint == 1"
        @close="closeModel"
        @update="update"
        :selectedData="selectedData"
      ></appoint>
    </page-model>
  </div>
</template>


<script>
import CheckJob from "./check";
import OutputFile from "./outputFile";
import Appoint from "./appoint";

const columns = [
  {
    title: "序号",
    customRender: (text, record, index) => `${index + 1}`,
  },
  {
    title: "协作组条码",
    dataIndex: "hosBarCode",
  },
  {
    title: "基因检测作业名称",
    scopedSlots: { customRender: "sampleId" },
    dataIndex: "sampleId",
  },
  {
    title: "状态",
    dataIndex: "sampleAmount",
  },
  {
    title: "审核状态",
    dataIndex: "sampleType",
  },
  {
    title: "审核意见",
    dataIndex: "address",
  },
  {
    title: "审核时间",
    dataIndex: "operateDate",
  },
  {
    title: "上传时间    ",
    dataIndex: "userName",
  },
];
export default {
  data() {
    return {
      columns,
      detail: {},
      fqList: [],
      editData: [],
      path: "",
      time: null,
      finishTime: "",
      visible: false,
      pvisible: false,
      loading: false,
      isAppoint: 0,
      selectedData: [],
    };
  },
  components: {
    Appoint,
  },
  mounted() {
    this.id = this.$route.query.id;
    this.getDetail();
  },
  methods: {
    appoint() {
      if (this.selectedData.length > 0) {
        let flag = true;
        for (let val of this.selectedData) {
          if (val.verifyId) {
            flag = true;
            break;
          } else {
            flag = false;
          }
        }
        if (!flag) {
          this.isAppoint = 1;
          this.pvisible = true;
        } else {
          this.$message.error("已经指派的作业不要重复指派");
        }
      }
    },
    closeModel() {
      this.pvisible = false;
      this.isAppoint = 0;
    },
    update() {
      this.getDetail();
    },
    // 高级操作
    operateJob(type) {
      let flag = false;
      if (
        type == 2 &&
        (this.detail.jobsStatus == "failed" ||
          this.detail.jobsStatus == "psudone")
      ) {
        flag = true;
      } else if (type == 4 && this.detail.jobsStatus == "running") {
        flag = true;
      } else if (
        type == 1 &&
        (this.detail.jobsStatus == "failed" ||
          this.detail.jobsStatus == "psudone" ||
          this.detail.jobsStatus == "cancel")
      ) {
        let queryData = {
          id: this.detail.id,
          bid: this.detail.bid,
        };
        this.$router.push({ path: "/job/add", query: queryData });
      }
      if (flag) {
        this.$post("jobsmanage/jobs/operateJob", {
          localJobsId: this.id,
          operationType: type,
        }).then((res) => {
          if (res.data.code == 1) {
            this.$message.success(res.data.message);
            this.getDetail();
          } else {
            this.$message.error(res.data.message);
          }
        });
      }
    },
    //获取详细信息
    getDetail() {
      let _this = this;
      this.selectedData = [];
      this.$get("/jobsmanage/jobs/detail/" + this.id).then((res) => {
        this.detail = res.data.data;
        this.selectedData.push(this.detail);
        clearInterval(this.time);
        if (this.detail.bid) {
          this.getFqList(this.detail.bid);
        }
        if (this.detail.jobsId) {
          this.getAllNeedSyncJobList();
          this.getCloudPlatformJobDetail(this.id);
        }
        this.finTime();
        if (
          this.detail.jobsStatus == "failed" ||
          this.detail.jobsStatus == "psudone" ||
          this.detail.jobsStatus == "cancel" ||
          this.detail.jobsStatus == "done"
        ) {
          if (this.time) {
            clearInterval(_this.time);
          }
        } else {
          this.time = setInterval(() => {
            _this.getDetail();
          }, 30000);
        }
      });
    },
    //获取fq文件列表
    getFqList(id) {
      this.$get("/cloudPlatformApi/getSampleByLocalJobId", {
        localJobId: this.id,
      }).then((res) => {
        this.fqList = res.data.data.result.records;
      });
    },
    // 查看作业进度
    getAllNeedSyncJobList() {
      this.$get("/cloudPlatformApi/getCloudPlatformJobProcess", {
        localJobsId: this.id,
      }).then((res) => {
        if (res.data.data) {
          if (res.data.data) {
            this.editData = res.data.data;
          }
        } else {
          this.editData = [];
        }
      });
    },
    // 获取作业目录
    getCloudPlatformJobDetail(id) {
      this.$get("/cloudPlatformApi/getCloudJobPath/" + id, {
        cloudPlatformJobId: id,
      }).then((res) => {
        this.path = res.data.data;
      });
    },
    finTime() {
      if (this.detail.startTime) {
        let startTime = new Date(this.detail.startTime).getTime();
        let endTime;
        if (this.detail.endTime) {
          endTime = new Date(this.detail.endTime).getTime();
        } else {
          endTime = new Date().getTime();
        }

        //获取时间差
        var timediff = Math.round((endTime - startTime) / 1000);
        //获取还剩多少天
        // var day = parseInt(timediff / 3600 / 24);
        //获取还剩多少小时
        var hour = parseInt(timediff / 3600);
        //获取还剩多少分钟
        var minute = parseInt((timediff / 60) % 60);
        //获取还剩多少秒
        var second = timediff % 60;
        if (hour < 10) {
          hour = "0" + hour;
        } else {
          hour = hour;
        }
        if (minute < 10) {
          minute = "0" + minute;
        } else {
          minute = minute;
        }
        if (second < 10) {
          second = "0" + second;
        } else {
          second = second;
        }
        this.finishTime = hour + ":" + minute + ":" + second;
        // day + "天" + hour + "小时" + minute + "分钟" + second + "秒";
      }
    },
    //判断jobIdc
    getJobdetail() {
      let _this = this;
      this.$get("/jobsmanage/jobs/detail/" + this.id).then((res) => {
        if (this.detail.jobsId) {
          this.getAllNeedSyncJobList();
        } else {
          this.$message.error("作业暂时没有执行");
        }
      });
    },
    //查看作业进度
    seeWorkProcess() {
      this.visible = true;
      this.getJobdetail();
    },
    //日志下载
    downLoad() {
      let upfile = JSON.parse(localStorage.getItem("uploadFile"));
      this.$get("cloudPlatformApi/downloadLogFileFromCloud", {
        localJobsId: this.id,
      }).then((res) => {
        if (res.data.code == 1) {
          let uri = upfile.fileHost + res.data.data;
          let index = res.data.data.lastIndexOf("/");
          let type = res.data.data.substr(index);
          //  window.open(uri)
          this.downFile(uri, type);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    downFile(fileName, type) {
      this.$axios.get(fileName, { responseType: "blob" }).then((response) => {
        var blob = new Blob([response.data]);
        var downloadElement = document.createElement("a");
        var href = window.URL.createObjectURL(blob); //创建下载的链接
        downloadElement.href = href;
        downloadElement.download = type; //下载后文件名
        document.body.appendChild(downloadElement);
        downloadElement.click(); //点击下载
        document.body.removeChild(downloadElement); //下载完成移除元素
        window.URL.revokeObjectURL(href);
        // }
      });
    },
    //关闭右侧弹框
    onClose() {
      this.visible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .c-not-allowed.ant-dropdown-menu-item {
  cursor: not-allowed;
}

.job-details {
  width: 100%;
  min-width: 1200px;
  /*/deep/ .job-details-content {*/
  /*background: #fff;*/
  /*}*/
  .breadcrumb {
    /deep/ .ant-breadcrumb {
      display: inline-block;
    }
  }
  .job-details-top {
    background-color: #fff;
    padding: 32px 60px 16px 60px;
  }
  .job-details-t-left {
    font-size: 18px;
    .iconfont {
      font-size: 22px;
      color: #a4a4a4;
    }
    span {
      color: #333333;
      font-weight: bold;
      margin-left: 10px;
    }
  }
  .job-details-t-right {
    text-align: right;
    padding-top: 12px;
  }
  .job-details-center {
    background-color: #f9fbfb;
    padding: 30px 60px;
  }
  .job-details-c-t,
  .job-details-c-b {
    background-color: #fff;
    margin-right: 20px;
  }
  .job-details-c-t {
    .job-details-info-b {
      border-top: 1px solid #f6f7f9;
      margin-top: 20px;
      padding: 37px 0 35px 10px;
    }
    .job-status-title {
      margin-top: 20px;
    }
    .right-group {
      padding-left: 10px;
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 400;
      .right-group-title {
        color: #a4a4a4;
        display: inline-block;
        margin-right: 20px;
        font-size: 14px;
      }
      .right-group-value {
        color: #333333;
      }
    }
    .right-group + .right-group {
      margin-left: 100px;
    }
    .content-container-left {
      padding: 35px 30px;
      .job-status {
        width: 160px;
        height: 100%;
        position: relative;
        .circle {
          width: 160px;
          height: 160px;
          padding-top: 60px;
          padding-left: 20px;
          padding-right: 20px;
          // line-height: 160px;
          text-align: center;
          background: cover;
        }
        .circle-img {
          background: url("../../assets/image/homeImg/work.gif") no-repeat
            center;
        }
        .circle-red {
          border: 8px solid rgba(255, 36, 38, 1);
          border-radius: 50%;
        }
        .circle-green {
          border: 8px solid #79c489;
          border-radius: 50%;
        }
        .circle-node-name {
          overflow: hidden;
          text-overflow: ellipsis;
          display: inline-block;
          width: 100%;
        }
        .circle-hui {
          border: 8px solid #c8c8c8;
          border-radius: 50%;
        }
        .title {
          position: absolute;
          bottom: 0;
          white-space: nowrap;
        }
      }
      .job-details-right-content {
        .group-content {
          padding-top: 78px;
          .title {
            font-size: 14px;
            font-family: PingFang SC;
            font-weight: 400;
            white-space: nowrap;
            color: rgba(164, 164, 164, 1);
          }
          .value {
            font-size: 14px;
            font-family: PingFang SC;
            font-weight: 400;
            white-space: nowrap;
            margin-top: 20px;
            color: rgba(51, 51, 51, 1);
          }
        }
        .group-content:last-child {
          .value {
            line-height: 30px;
            text-align: left;
          }
          .link {
            float: inherit;
            margin-left: 20px;
          }
        }
      }
    }
  }
  .job-details-c-b {
    margin-top: 20px;
    .content-container-right {
      padding: 35px 30px;
      padding-top: 22px;
      .title {
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
      }
      .fq-container {
        .fq-file {
          font-size: 13px;
          font-family: PingFang SC;
          font-weight: 400;
          color: rgba(22, 34, 50, 1);
          margin-top: 15px;
        }
      }
    }
  }
  .job-details-c-r {
    padding: 20px 20px;
    background-color: #f0f2f5;
  }

  .job-form-item {
    margin: 15px 0;
    line-height: 30px;
    .job-form-item-label {
      font-size: 14px;
      color: #a4a4a4;
    }
    .job-form-item-val {
      font-size: 16px;
      color: #333333;
      word-wrap: break-word;
    }
  }
}
</style>